export default __webpack_public_path__ + "static/media/getbannerbottom.68094155bb269ea995433c533c99ea76.svg";